// Reference content from content/*.json: texts, turbine type, fleet, fault catalogue, service organisation, colours, roads.
export var EN, TURB, FLEET, FAULTS, FAULT, LOG, THEME, COMP, ROADS;

export function initContent(c) {
  EN = c.en; TURB = c.turbine; FLEET = c.fleet; FAULTS = c.faults; LOG = c.logistics; THEME = c.theme; ROADS = c.roads;
  FAULT = {}; FAULTS.faults.forEach(function (f) { FAULT[f.id] = f; });
  COMP = {}; TURB.components.forEach(function (k) { COMP[k.id] = k; });
}
